const React = require('react')
const { useEffect } = require('react')
const { Header } = require('./header.layout')
const { Footer } = require('./footer.layout')
const { useNetworkConfig } = require('@contexts')
const { useResponsive, BREAKPOINTS } = require('@hooks')

const Layout = ({ children }) => {
    const { network } = useNetworkConfig()
    const isMobile = useResponsive(BREAKPOINTS.extraLarge)

    useEffect(() => {
        if (isMobile) {
            document.querySelector('.main-body').style.backgroundImage = 'none'
            return
        }
        document.querySelector('.main-body').style.backgroundImage = `url(${network.data.backgroundImage})`
    }, [network.name, network.data.backgroundImage, isMobile])

    return (
        <>
            <Header />
            <div className='main-body'>{children}</div>
            <Footer />
        </>
    )
}

module.exports = { Layout }
